import { Country } from '@/helpers/conf';
import { Locale } from '@/helpers/languages';

export const detectUserLocale = (language: string, country: string) => {
  const MAPPER: Record<string, Record<string, string>> = {
    de: { default: Locale.GERMAN },
    en: {
      [Country.Australia]: Locale.ENGLISH_AUSTRALIA,
      [Country.Canada]: Locale.ENGLISH_CANADA,
      [Country.Germany]: Locale.ENGLISH,
      [Country.Switzerland]: Locale.ENGLISH,
      [Country.Ireland]: Locale.ENGLISH_IRELAND,
      [Country.NewZealand]: Locale.ENGLISH_NEW_ZEALAND,
      default: Locale.ENGLISH,
    },
    fr: {
      [Country.Canada]: Locale.FRENCH_CANADA,
      [Country.Switzerland]: Locale.FRENCH_SWITZERLAND,
      default: Locale.FRENCH_SWITZERLAND,
    },
    'fr-CH': {
      [Country.Canada]: Locale.FRENCH_CANADA,
      [Country.Switzerland]: Locale.FRENCH_SWITZERLAND,
      default: Locale.FRENCH_SWITZERLAND,
    },
    'fr-CA': {
      [Country.Canada]: Locale.FRENCH_CANADA,
      default: Locale.FRENCH_CANADA,
    },
    default: {
      [Country.Canada]: Locale.ENGLISH_CANADA,
      [Country.NewZealand]: Locale.ENGLISH_NEW_ZEALAND,
      [Country.Ireland]: Locale.ENGLISH_IRELAND,
      [Country.Australia]: Locale.ENGLISH_AUSTRALIA,
      default: Locale.ENGLISH,
    },
  };

  const languageMapping = MAPPER[language] || MAPPER.default;
  return languageMapping[country] || languageMapping.default;
};
